import { createAction, props } from "@ngrx/store";
import { RankListResponseWrapper } from "src/app/api/models";

export enum RoomchampionsActionTypes {
    LOAD_ROOMCHAMPIONS = '[Roomchampions] load many',
    LOAD_ROOMCHAMPIONS_FAIL = '[Roomchampions] load many fail',
    LOAD_ROOMCHAMPIONS_SUCCESS = '[Roomchampions] load many success',
}

export const loadMany = createAction(RoomchampionsActionTypes.LOAD_ROOMCHAMPIONS, props<{ room: string, nameSpace: string }>());
export const loadManyFail = createAction(RoomchampionsActionTypes.LOAD_ROOMCHAMPIONS_FAIL, props<{ error: object }>());
export const loadManySuccess = createAction(RoomchampionsActionTypes.LOAD_ROOMCHAMPIONS_SUCCESS, props<{ items: RankListResponseWrapper[] }>());